export const userManagementUrl = '/cp/user_management';
